<template>
    <div className="col-md-8 align-items-center">
        <b-card-code class="mt-2 principal">
            
            <div className = "align-items-center text-align-center">
                <img :src="codigoQR" alt="qr"  style="width: 30%; height: 30%;">
            </div>
        </b-card-code>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import { BButton } from 'bootstrap-vue'
import QRCode from 'qrcode';

export default {
    
    components: {
        BButton,
        BCardCode,
    },
    data() {
        return {
            codigoQR: '',
            id:''
        }
    },
    mounted() {
        this.generarCodigoQR(); // Llama a la función de generación de código QR automáticamente al montar el componente
    },
    created() {
        this.comprobarPermisos();
    },
    methods: {
        comprobarPermisos() {
      if (localStorage.getItem('permisos').indexOf('citamedica_codigoqr') === -1) {
        this.$router.push({ name: 'not-permitted' })
      }
    },
        generarCodigoQR() {
            const token = this.$route.params.token;  // ID que deseas pasar al escanear el código QR
            const url = window.location.origin + '/calificacion_atencionmedica/' + token; // URL de destino con el ID
            QRCode.toDataURL(url, (err, url) => {
                if (err) console.error(err)
                console.log('Código QR generado:', url)
                this.codigoQR = url; // Guarda el código QR generado en una variable de datos
            });
        },
        goToEncuesta() {
            this.$router.push({ name: 'codigo_qr' });
        },
    }
}
</script>

<style>
.principal .card-header {
    display: none !important;
}

.principal .card-body {
    padding-bottom: 0 !important;
}
</style>

<style scoped src="@/assets/css/dropfile.css"></style>